import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Hero } from "@/components/home/Hero";
import { TrustStrip } from "@/components/home/TrustStrip";
import { SearchPanel } from "@/components/home/SearchPanel";
import { LatestListings } from "@/components/home/LatestListings";
import { HundredPercent } from "@/components/home/HundredPercent";
import { PricingTeaser } from "@/components/pricing/PricingTeaser";
import { RecommendedListings } from "@/components/home/RecommendedListings";
import { Reveal } from "@/components/Motion";

export default function Landing() {
  const [items, setItems] = useState([]);
  const [makes, setMakes] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/listings", { params: { sort: "newest" } })
      .then(({ data }) => { setItems(data.items.slice(0, 8)); setMakes(data.makes); })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <div data-testid="landing-page">
      <Hero />
      <TrustStrip />
      <SearchPanel makes={makes} />
      <RecommendedListings />
      <LatestListings items={items} loaded={loaded} />
      <HundredPercent />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-24 lg:pt-36" data-testid="plans-section">
        <Reveal>
          <span className="text-xs uppercase tracking-widest font-semibold text-teal">Plans</span>
          <h2 className="font-heading font-extrabold text-navy tracking-tighter text-3xl sm:text-5xl mt-2">Two ways to sell. Both simple.</h2>
        </Reveal>
        <div className="mt-10 max-w-3xl"><PricingTeaser /></div>
        <p className="text-xs text-slatev mt-8">
          Vorra is a marketplace, not the seller, and is not a party to any sale. <Link to="/legal/liability" className="underline">Platform terms</Link>.
        </p>
      </section>
    </div>
  );
}
